import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "atlas-app" }
const _hoisted_2 = {
  key: 0,
  class: "atlas-overlay"
}

import Spinner from '@/components/spinner/Spinner.vue';
import { useApi } from '@/services/api-service';
import { useStore } from "@/stores/store";
import { ISearchResult } from '@/interfaces/search/ISearchResult';
import { onBeforeMount } from 'vue';
import { useFilterApply } from '@/services/filter-apply-service';
import { useSearch } from '@/services/search-service';

const searchLoadErrorMessage = 'Just nu har vi problem med att visa kartan, prova igen om en stund.';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const { get: search, loading: searching } = useApi(`/atlas/Search`);
const { applyFilters } = useFilterApply();
const { sortSearchResult } = useSearch();
onBeforeMount(() => {
  store.apiErrorMessage = null;
  search<ISearchResult>().then((response: ISearchResult) => {
    store.searchResult = response;
    store.originalSearchResult = response;
    applyFilters();
    sortSearchResult('name', store.sorting.descending);
  }).catch(() => {
    store.apiErrorMessage = searchLoadErrorMessage;
    store.searchResult = null;
    store.originalSearchResult = null;
  });
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ]),
    (_unref(searching))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(Spinner, { class: "atlas-overlay__spinner" })
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})